export const saacReps = [
    /* =================== EXECUTIVE BOARD ================== */
    // Kiara Kraft
    {
        id: "kiaraKraft",
        execBoard: true,
        name: "Kiara Kraft '27",
        title: "President ",
        image: "assets/media/pages/saac/kiara-kraft-25.webp",
        sport: "Women's Ice Hockey",
    },
    // Macie Pennisi
    {
        id: "maciePennisi",
        execBoard: true,
        name: "Macie Pennisi '27",
        title: "Vice President Community Engagement",
        image: "assets/media/pages/saac/macie-pennisi-25.webp",
        sport: "Field Hockey",
    },
    // Ava Ripanti
    // MarkUp #500
    {
        id: "avaRipanti",
        execBoard: true,
        name: "Ava Ripanti '27",
        title: "Vice President of Health & Wellness",
        image: "assets/media/pages/saac/ripanti-26.webp",
        sport: "Women's Soccer",
    },
    // Lyric Berry
    {
        id: "lyricBerry",
        execBoard: true,
        name: "Lyric Berry '27",
        title: "Vice President Communications",
        image: "assets/media/pages/saac/lyric-berry.webp",
        sport: "Volleyball",
    },
    // Stone Evans
    {
        id: "stoneEvans",
        execBoard: true,
        name: "Stone Evans '28",
        title: "Vice President of Beloved Community",
        image: "assets/media/pages/saac/stone-evans.webp",
        sport: "Lacrosse",
    },
    /* ===================== OTHER REPS ===================== */
    // MarkUp #520 - Aidan Puk removed

    // Aleksi Kivioja
    // MarkUp #498
    {
        id: "aleksiKivioja",
        name: "Aleksi Kivioja",
        image: "assets/media/pages/saac/aleksi-kivioja.webp",
        sport: "Men's Ice Hockey",
    },
    // Ariana Granatelli
    {
        id: "arianaGranatelli",
        name: "Ariana Granatelli",
        image: "assets/media/pages/saac/ariana-granatelli.webp",
        sport: "Cheer",
    },
    // Camila Barrera
    {
        id: "camilaBarrera",
        name: "Camila Barrera",
        image: "assets/media/pages/saac/camilla-barrera.webp",
        sport: "Tennis",
    },
    // Campbell Skelly
    {
        id: "campbellSkelly",
        name: "Campbell Skelly",
        image: "assets/media/pages/saac/campbell-Skelly.webp",
        sport: "Men's Golf",
    },
    // Caroline Kelly
    {
        id: "carolineKelly",
        name: "Caroline Kelly",
        image: "assets/media/pages/saac/caroline-kelly.webp",
        sport: "Swimming/Diving",
    },
    // Colin Gols
    {
        id: "colinGols",
        name: "Colin Gols",
        image: "assets/media/pages/saac/colin-gols.webp",
        sport: "Lacrosse",
    },
    // Delia Fritz
    {
        id: "deliaFritz",
        name: "Delia Fritz",
        image: "assets/media/pages/saac/delia-fritz.webp",
        sport: "Swimming/Diving",
    },
    // Dylan Berman
    {
        id: "dylanBerman",
        name: "Dylan Berman",
        image: "assets/media/pages/saac/dylan-berman.webp",
        sport: "Women's Ice Hockey",
    },
    // Emma Eichten
    {
        id: "emmaEichten",
        name: "Emma Eichten",
        image: "assets/media/pages/saac/emma-eichten.webp",
        sport: "Softball",
    },
    // Emma Peifly
    {
        id: "emmaPeifly",
        name: "Emma Peifly",
        image: "assets/media/pages/saac/emma-peifly.webp",
        sport: "Women's Golf",
    },
    // Erika Beltran
    {
        id: "erikaBeltran",
        name: "Erika Beltran",
        image: "assets/media/pages/saac/erika-beltran.webp",
        sport: "Tennis",
    },
    // Evan Buddenhagen
    {
        id: "evanBuddenhagen",
        name: "Evan Buddenhagen",
        image: "assets/media/pages/saac/evan-buddenhagen.webp",
        sport: "Men's Golf",
    },
    // Florencia Talerico
    {
        id: "florenciaTalerico",
        name: "Florencia Talerico",
        image: "assets/media/pages/saac/florencia-talerico.webp",
        sport: "Field Hockey",
    },
    // Graham Gamache
    {
        id: "grahamGamache",
        name: "Graham Gamache",
        image: "assets/media/pages/saac/graham-gamache.webp",
        sport: "Men's Ice Hockey",
    },
    // Haley Gould
    // MarkUp #498
    {
        id: "haleyGould",
        name: "Haley Gould",
        image: "assets/media/pages/saac/haley-gould.webp",
        sport: "Dance",
    },
    // Hunter Bisbee
    {
        id: "hunterBisbee",
        name: "Hunter Bisbee",
        image: "assets/media/pages/saac/hunter-bisbee.webp",
        sport: "Lacrosse",
    },
    // Ivan Reber
    // MarkUp #498
    {
        id: "ivanReber",
        name: "Ivan Reber",
        image: "assets/media/pages/saac/ivan-reber.webp",
        sport: "Men's Swimming/Diving",
    },
    // J'Adore Young
    // MarkUp #498
    {
        id: "jadoreYoung",
        name: "J'Adore Young",
        image: "assets/media/pages/saac/jadore-young.webp",
        sport: "Women's Basketball",
    },
    // Johnny Jackson
    // MarkUp #498
    {
        id: "johnnyJackson",
        name: "Johnny Jackson",
        image: "assets/media/pages/saac/johnny-jackson.webp",
        sport: "Men's Basketball",
    },
    // Jonah Unruh
    {
        id: "jonahUnruh",
        name: "Jonah Unruh",
        image: "assets/media/pages/saac/jonah-unruh.webp",
        sport: "Men's Swimming/Diving",
    },
    // Josie Lang
    {
        id: "josieLang",
        name: "Josie Lang",
        image: "assets/media/pages/saac/josie-lang.webp",
        sport: "Women's Ice Hockey",
    },
    // Kaelin McCaffrey
    // MarkUp #498
    {
        id: "kaelinMccaffrey",
        name: "Kaelin McCaffrey",
        image: "assets/media/pages/saac/kaelin-mccaffrey.webp",
        sport: "Women's Track",
    },
    // Keira Kelly
    {
        id: "keiraKelly",
        name: "Keira Kelly",
        image: "assets/media/pages/saac/keira-kelly.webp",
        sport: "Women's Track",
    },
    // Kelly Stepnowski
    {
        id: "kellyStepnowski",
        name: "Kelly Stepnowski",
        image: "assets/media/pages/saac/Kelly-Stepnowski.webp",
        sport: "Women's Soccer",
    },
    // Liza Goetcheus
    {
        id: "lizaGoetcheus",
        name: "Liza Goetcheus",
        image: "assets/media/pages/saac/liza-goetcheus.webp",
        sport: "Swimming/Diving",
    },
    // Macy Taylor
    {
        id: "macyTaylor",
        name: "Macy Taylor",
        image: "assets/media/pages/saac/macy-taylor.webp",
        sport: "Volleyball",
    },
    // Mayow Ajayi
    // MarkUp #498
    {
        id: "mayowAjayi",
        name: "Mayow Ajayi",
        image: "assets/media/pages/saac/mayow-ajayi.webp",
        sport: "Men's Soccer",
    },
    // Michael Vella
    // MarkUp #498
    {
        id: "michaelVella",
        name: "Michael Vella",
        image: "assets/media/pages/saac/michael-vella.webp",
        sport: "Men's Soccer",
    },
    // Myla Bisceglia
    // MarkUp #498
    {
        id: "mylaBisceglia",
        name: "Myla Bisceglia",
        image: "assets/media/pages/saac/myla-bisceglia.webp",
        sport: "Women's Golf",
    },
    // Natalia Robak
    {
        id: "nataliaRobak",
        name: "Natalia Robak",
        image: "assets/media/pages/saac/natalia-robak.webp",
        sport: "Swimming/Diving",
    },
    // Paige Daly
    {
        id: "paigeDaly",
        name: "Paige Daly",
        image: "assets/media/pages/saac/paige-daly.webp",
        sport: "Dance",
    },
    // Patrick Mullin
    // MarkUp #498
    {
        id: "patrickMullin",
        name: "Patrick Mullin",
        image: "assets/media/pages/saac/patrick-mullin.webp",
        sport: "Lacrosse",
    },
    // Payton Dunbar
    {
        id: "paytonDunbar",
        name: "Payton Dunbar",
        image: "assets/media/pages/saac/payton-dunbar.webp",
        sport: "Women's Basketball",
    },
    // Piper Cline
    // MarkUp #498
    {
        id: "piperCline",
        name: "Piper Cline",
        image: "assets/media/pages/saac/piper-cline.webp",
        sport: "Field Hockey",
    },
    // Polly Bogdan
    {
        id: "pollyBogdan",
        name: "Polly Bogdan",
        image: "assets/media/pages/saac/polly-bogdan.webp",
        sport: "Women's Track",
    },
    // Rebecca Weaver
    {
        id: "rebeccaWeaver",
        name: "Rebecca Weaver",
        image: "assets/media/pages/saac/becca-weaver.webp",
        sport: "Softball",
    },
    // Ryan Welch
    {
        id: "ryanWelch",
        name: "Ryan Welch",
        image: "assets/media/pages/saac/ryan-welch.webp",
        sport: "Men's Cross Country/Track",
    },
    // Sofia Darsinos
    {
        id: "sofiaDarsinos",
        name: "Sofia Darsinos",
        image: "assets/media/pages/saac/sofia-darsinos.webp",
        sport: "Cheer",
    },
    // Sophi Hall
    {
        id: "sophiHall",
        name: "Sophi Hall",
        image: "assets/media/pages/saac/sophi-hall.webp",
        sport: "Women's Basketball",
    },
    // Sophia Adkins
    {
        id: "sophiaAdkins",
        name: "Sophia Adkins",
        image: "assets/media/pages/saac/sophia-adkins.webp",
        sport: "Volleyball",
    },
    // Stephanie Schoeley
    // MarkUp #498
    {
        id: "stephanieSchoeley",
        name: "Stephanie Schoeley",
        image: "assets/media/pages/saac/stephanie-schoeley.webp",
        sport: "Women's Soccer",
    },
    // Tyler Bartlett
    {
        id: "tylerBartlett",
        name: "Tyler Bartlett",
        image: "assets/media/pages/saac/tyler-bartlett.webp",
        sport: "Cross Country/Track",
    },
];
